import { Card, CardContent, Typography } from "@material-ui/core";
import Dropdown from "src/components/Dropdown";
import { SimpleListItemProps } from "src/utils";

const SimpleListItem: React.FC<SimpleListItemProps> = ({ items }) => {
  const itemsComponent = items.map((item) => (
    <Card className="list-item" key={item.id}>
      <CardContent>
        <Typography className="title" variant="subtitle1">
          {item.title}
        </Typography>

        <Typography className="body color-light-grey" variant="body2">
          {item.subtitle}
        </Typography>
      </CardContent>

      {item.options && <Dropdown options={item.options} />}
    </Card>
  ));

  return <div className="simple-list">{itemsComponent}</div>;
};

export default SimpleListItem;
